export default __webpack_public_path__ + "static/media/baseline-signal_wifi_4_bar-24px.3b8ac81b.svg";